import { callCSSFn, CSSFn, styled, StyleProps } from "../styles"

type BadgeVariant = `brand` | `default` | `info` | `valid` | `alert` | `error` | `secondary`
type BadgeSize = `lg`

interface IBadgeProps {
  size?: BadgeSize
  variant?: BadgeVariant
  css?: CSSFn
}

type BadgeProps = IBadgeProps & StyleProps

const getBackgroundColor = (props: BadgeProps) => {
  switch (props.variant) {
    case `valid`:
      return props.theme.palette.valid
    case `error`:
      return props.theme.palette.error
    case `brand`:
      return props.theme.palette.brand
    case `alert`:
      return props.theme.palette.alert
    case `info`:
      return props.theme.palette.info
    case `default`:
      return props.theme.palette.coal.dark
    case `secondary`:
    default:
      return props.theme.palette.grey.dark
  }
}

const getColor = (props: BadgeProps) => {
  switch (props.variant) {
    case `valid`:
    case `error`:
    case `default`:
      return props.theme.palette.white
    case `secondary`:
    case `brand`:
    case `alert`:
    case `info`:
    default:
      return props.theme.palette.coal.dark
  }
}

export const Badge = styled.span<BadgeProps>((props: BadgeProps) => ({
  ...props.theme.fonts.body,
  display: `inline-block`,
  color: getColor(props),
  fontSize: props.size === undefined ? props.theme.fontSize.caption : props.theme.fontSize.body,
  textTransform: props.size === undefined ? `uppercase` : `none`,
  lineHeight: 1,
  textAlign: `center`,
  whiteSpace: `nowrap`,
  verticalAlign: `baseline`,
  backgroundColor: getBackgroundColor(props),
  padding: props.size === undefined ? props.theme.spacing(1, 2) : props.theme.spacing(2, 6),
  borderRadius: props.size === undefined ? `12px` : `35px`,
  ...callCSSFn(props),
}))
